// Project dependencies
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Switch } from 'react-router';
import { Router } from 'react-router-dom';
import { PkceProvider, PkceSecure } from '@oliasoft/pkce';
import WithRuntimeConfig from './hocs/withRuntimeConfig';
import { getConfig } from './constants';
import { Toaster } from './common/Notifications';
import MainRoutesContainer from './layout/MainRoutesContainer';
import '~translation/i18n';
import { history, store } from './reduxStore';
import './styles/new-global.less';
import '@oliasoft-open-source/react-ui-library/dist/global.css';

function Loading() {
  return <div>Loading ...</div>;
}

const App = () => {
  const config = getConfig();
  return (
    <PkceProvider
      provider={config.provider}
      renewTokenMode={config.renewTokenMode}
      clientId={config.clientId}
      idpServerUrl={config.idpServerUrl}
      hostBaseUrl={config.hostBaseUrl}
      history={history}
    >
      <Router history={history}>
        <PkceSecure>
          <Switch>
            <MainRoutesContainer store={store} />
          </Switch>
        </PkceSecure>
      </Router>
    </PkceProvider>
  );
};

createRoot(document.getElementById('tlcont')).render(
  <Suspense fallback={<Loading />}>
    <WithRuntimeConfig>
      <Provider store={store}>
        <App />
        <Toaster />
      </Provider>
    </WithRuntimeConfig>
  </Suspense>,
);
